/* Velqent Motion – weiches Scrollen (Trägheit), Scroll-Einblendungen, Parallax.
   Ohne externe Bibliotheken. Einstellungen kommen aus window.VQ_MOTION (snippets/theme-styles.liquid). */
(function () {
  var cfg = window.VQ_MOTION || {};
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  window.__vqMotionReady = true;

  /* ---------- 1. Weiches Scrollen mit Trägheit (nur Maus/Trackpad am Desktop) ---------- */
  var smooth = cfg.smooth && !reduce && !design && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var target = window.scrollY, current = window.scrollY, raf = null, selfScroll = false;
  var ease = Math.min(0.2, Math.max(0.04, 0.2 - (cfg.intensity || 5) * 0.015)); // Stufe 1 = direkt, 10 = sehr weich

  function maxScroll() { return root.scrollHeight - window.innerHeight; }
  function clamp(v) { return Math.max(0, Math.min(maxScroll(), v)); }

  function innerScrollable(el, dy) {
    while (el && el !== document.body && el !== root) {
      var st = getComputedStyle(el);
      if (/(auto|scroll)/.test(st.overflowY) && el.scrollHeight > el.clientHeight + 1) {
        if (dy < 0 && el.scrollTop > 0) return true;
        if (dy > 0 && el.scrollTop + el.clientHeight < el.scrollHeight - 1) return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  function loop() {
    current += (target - current) * ease;
    if (Math.abs(target - current) < 0.4) current = target;
    selfScroll = true;
    window.scrollTo(0, current);
    if (current !== target) raf = requestAnimationFrame(loop);
    else raf = null;
  }
  function start() { if (!raf) raf = requestAnimationFrame(loop); }

  function scrollToY(y) {
    if (!smooth) { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); return; }
    if (!raf) current = window.scrollY;
    target = clamp(y); start();
  }
  window.vqScrollTo = scrollToY;

  if (smooth) {
    root.style.scrollBehavior = 'auto';
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented) return;
      var dy = e.deltaY * (e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? window.innerHeight : 1);
      if (Math.abs(e.deltaX) > Math.abs(dy)) return;           // horizontales Wischen nicht abfangen
      if (innerScrollable(e.target, dy)) return;                // z. B. Textfelder, Menüs
      if (document.querySelector('details.menu-toggle[open]')) return;
      e.preventDefault();
      if (!raf) current = target = window.scrollY;
      target = clamp(target + dy);
      start();
    }, { passive: false });

    // Tastatur, Scrollbar-Ziehen etc. bleiben nativ – danach synchronisieren
    window.addEventListener('scroll', function () {
      if (selfScroll) { selfScroll = false; return; }
      if (!raf) current = target = window.scrollY;
    }, { passive: true });
    window.addEventListener('resize', function () { target = clamp(target); });
  }

  // Anker-Links (#leistungen, #kontakt …) weich ansteuern
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
    var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!el) return;
    e.preventDefault();
    var offset = parseInt(getComputedStyle(root).scrollPaddingTop, 10) || 0;
    scrollToY(el.getBoundingClientRect().top + window.scrollY - offset);
    history.pushState(null, '', url.hash);
    var menu = a.closest('details'); if (menu) menu.removeAttribute('open');
  });

  /* ---------- 2. Einblenden beim Scrollen ---------- */
  var SEL = [
    '.hero .eyebrow', '.hero h1', '.hero .lead', '.hero .actions',
    '.section .eyebrow', '.section h1', '.section h2', '.section .intro',
    '.cols>div', '.steps>li', '.packages>.package', '.benefits>.benefit', '.promo-card', '.trust-inline', '.packages-note', '.product-info', '.gallery', '.faq>details', '.form', '.section .wrap>.actions',
    '.split>div', '.grid>.card', '.articles>.article-card', '.narrow>.rte',
    '.footer-top>div', '.footer-bottom'
  ].join(',');

  function prepare(scope) {
    var els = scope.querySelectorAll(SEL);
    els.forEach(function (el) {
      // Versatz für Geschwister (Karten, Schritte, Fragen nacheinander)
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(SEL); });
      el.style.setProperty('--i', Math.min(sibs.indexOf(el), 6));
      el.querySelectorAll('.list li').forEach(function (li, i) { li.style.setProperty('--li', i); });
    });
    return els;
  }

  if (root.classList.contains('vq-motion')) {
    var els = prepare(document);
    if (design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    }
    document.addEventListener('shopify:section:load', function (e) {
      prepare(e.target).forEach(function (el) { el.classList.add('is-in'); });
    });
  }

  /* ---------- 3. Parallax ---------- */
  if (cfg.parallax && !reduce) {
    var layers = [];
    document.querySelectorAll('.hero-visual > *').forEach(function (el) { layers.push({ el: el, speed: 0.22, rotate: 0.02 }); });
    document.querySelectorAll('.split img').forEach(function (el) { layers.push({ el: el, speed: -0.06, scale: 1.08 }); });
    layers.forEach(function (l) { l.el.setAttribute('data-vq-parallax', ''); });
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      layers.forEach(function (l) {
        var r = l.el.getBoundingClientRect();
        var center = r.top + r.height / 2 - vh / 2;
        if (r.bottom < -200 || r.top > vh + 200) return;
        var y = -center * l.speed;
        var t = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
        if (l.rotate) t += ' rotate(' + (-center * l.rotate).toFixed(2) + 'deg)';
        if (l.scale) t += ' scale(' + l.scale + ')';
        l.el.style.transform = t;
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();
